let controller = function (
	$scope,
	$state,
	$ionicLoading,
	Invoice
) {
	'ngInject'

	var vm = this;

	function initialize() {
		$ionicLoading.show();
		var id = parseInt($state.params.id);
		Invoice.details(id).then(function(res) {
			vm.invoice = res.data;
			vm.total = _.reduce(vm.invoice.products, function(mem, item) {
				return mem+item.product.price;
			}, 0);
			vm.groups = _.groupBy(vm.invoice.products, function(item) {
				return item.product_id;
			});
			$ionicLoading.hide();
		});
	}

	$scope.$on('$ionicView.enter', function(e) {
		initialize();
	});
}

export default controller


// WEBPACK FOOTER //
// ./app/components/invoices/details/details.controller.js